import { Linkedin, Facebook } from "lucide-react";

export default function Footer() {
    return (
        <footer className="py-12 border-t bg-background">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
                <div>
                    <img src="/img/logo.png" alt="Musab Digale Logo" className="h-8 w-auto grayscale brightness-200" />
                </div>
                <div className="flex space-x-6">
                    <a href="https://www.linkedin.com/in/musab-digale-273298310/" className="text-muted-foreground hover:text-foreground transition-colors">
                        <Linkedin className="w-5 h-5" />
                    </a>
                    <a href="https://www.facebook.com/Musabdigale" className="text-muted-foreground hover:text-foreground transition-colors">
                        <Facebook className="w-5 h-5" />
                    </a>
                </div>

                <div className="text-sm text-muted-foreground">
                    &copy; 2026 Musab Digale. All rights reserved.
                </div>
            </div>
        </footer>
    );
}
